import * as React from 'react';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import { Wrapper } from './loadingTextIndicator.styles';

type Props = {
  color?: ThemeColorType;
  isPaused?: boolean;
  label?: string;
} & Omit<React.HTMLProps<HTMLSpanElement>, 'ref' | 'as'>;

export const LoadingTextIndicator = ({
  color,
  isPaused,
  label = gettext('Loading'),
  ...props
}: Props) => (
  <Wrapper $color={color} isPaused={isPaused} {...props}>
    {label}
  </Wrapper>
);
